// H:\PricingPenguin\PricingPenguinProj\pricing_penguin_frontend\src\middleware\AuthMiddleware.jsx

import useAuth from "../hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export default function AuthMiddleware() {
  const { accessToken } = useAuth();
  const location = useLocation();

  if (accessToken) {
    return <Outlet />;
  } else {
    return <Navigate to="/home" state={{ from: location }} replace />;
  }
}